import { downloadTypes as actionTypes } from '@actions';
import { commonState, commonReducer, pagination } from '@dotone/react-ui-core/helpers';

const defaultState = {
  ...commonState.default({ collection: true }),
  pagination,
};

export const downloadList = (state = defaultState, action) =>
  commonReducer(actionTypes.LIST, state, action);

export const downloadDelete = (state = defaultState, action) =>
  commonReducer(actionTypes.DELETE, state, action);
